module.exports = __webpack_public_path__ + "static/media/GengibreLimao_250.66e773eb.jpg";